import React from 'react';
import {
  LineContent,
  Circle,
  CardContent,
  CardHeader,
  SimpleCircle,
  Separator,
  GraphBar,
  CardContentCalifications,
  CardContentReports,
  GhaphImgContainer,
  HorizontalSeparator
} from './styles';
import Star from '../../assets/icons/skeleton-star.svg';
import GhaphImg from '../../assets/img/graph-reports.svg';
import SectionLayout from '../SectionLayout';

const ReputationSkeleton = ({ device }) => {
  const isMobile = device === 'mobile';
  const isTablet = device === 'tablet';
  const isDesktop = device === 'desktop';
  return (
    <>
      <SectionLayout>
        <CardHeader>
          <div>
            <SimpleCircle w={48} h={48} isCircular />
            <LineContent width='100px' />
          </div>
          {!isMobile && <LineContent width='155px' />}
        </CardHeader>
        <CardContent isMobile={isMobile}>
          <div className='left fist-section'>
            <div className='star-section'>
              <LineContent width='88px' height='32px' />
              <div>
                <div className='stars-container'>
                  <img src={Star} alt='Star' height={20} width={20} />
                  <img src={Star} alt='Star' height={20} width={20} />
                  <img src={Star} alt='Star' height={20} width={20} />
                  <img src={Star} alt='Star' height={20} width={20} />
                  <img src={Star} alt='Star' height={20} width={20} />
                </div>
                <LineContent width='150px' />
              </div>
            </div>
            <LineContent width='298px' height='16px' marginTop='32px' />
            <LineContent width='233px' height='16px' marginTop='16px' />
            <LineContent width='298px' height='16px' marginTop='16px' />
            <LineContent width='232px' height='16px' marginTop='16px' />
          </div>
          {isMobile ? <HorizontalSeparator /> : null}

          {isDesktop && (
            <>
              <div className='right'>
                <div className='block-container'>
                  <LineContent width='69px' height='30px' />
                  <div className='graph-container'>
                    <LineContent width='72px' height='16px' marginRight='52px' />
                  </div>
                </div>
                <div className='block-container'>
                  <LineContent width='424px' height='16px' />
                </div>
                <div className='block-container'>
                  <LineContent width='489px' height='16px' />
                </div>
                <div className='block-container'>
                  <LineContent width='149px' height='16px' />
                </div>
                <div className='block-container'>
                  <div className='graph-container'>
                    <LineContent width='95px' height='24px' marginRight='52px' />
                  </div>
                </div>
                <HorizontalSeparator marginBottom='16px' marginTop='16px' />
              </div>
            </>
          )}

          {isTablet && (
            <>
              <div className='right'>
                <div className='block-container'>
                  <LineContent width='69px' height='30px' />
                  <div className='graph-container'>
                    <LineContent width='72px' height='16px' marginRight='52px' />
                  </div>
                </div>
                <div className='block-container'>
                  <LineContent width='424px' height='16px' />
                </div>
                <div className='block-container'>
                  <LineContent width='489px' height='16px' />
                </div>
                <div className='block-container'>
                  <LineContent width='149px' height='16px' />
                </div>
                <div className='block-container'>
                  <div className='graph-container'>
                    <LineContent width='95px' height='24px' marginRight='52px' />
                  </div>
                </div>
                <HorizontalSeparator marginBottom='16px' marginTop='16px' />
              </div>
            </>
          )}

          {isMobile && (
            <>
              <div className='right'>
                <div className='block-container'>
                  <LineContent width='69px' height='30px' />
                  <div className='graph-container'>
                    <LineContent width='72px' height='16px' />
                  </div>
                </div>
                <div className='block-container'>
                  <LineContent width='243px' height='16px' />
                </div>
                <div className='block-container'>
                  <LineContent width='281px' height='16px' />
                </div>
                <div className='block-container'>
                  <LineContent width='149px' height='16px' />
                </div>
                <div className='block-container'>
                  <div className='graph-container'>
                    <LineContent width='95px' height='24px' />
                  </div>
                </div>
                <HorizontalSeparator marginBottom='16px' marginTop='16px' />

                <div className='mobile-title-container'>
                  <LineContent width='164px' />
                </div>
              </div>
            </>
          )}
        </CardContent>
      </SectionLayout>
      <SectionLayout>
        <CardHeader>
          <div>
            <SimpleCircle w={48} h={48} isCircular />
            <LineContent width='100px' />
          </div>
        </CardHeader>
        <CardContentCalifications isMobile={isMobile}>
          <div className='left'>
            <Circle width='100px' height='100px' />
            <div className='label-container'>
              <LineContent width='122px' height='16px' />
              <LineContent width='76px' height='24px' />
            </div>
          </div>
          {isMobile ? <HorizontalSeparator /> : <Separator />}
          <div className='right'>
            <div className='block-container'>
              <LineContent width='150px' />
              <div className='graph-container'>
                <GraphBar />
                <SimpleCircle w={19} h={16} isCircular />
              </div>
            </div>
            <div className='block-container'>
              <LineContent width='165px' />
              <div className='graph-container'>
                <GraphBar />
                <SimpleCircle w={19} h={16} isCircular />
              </div>
            </div>
            <div className='block-container'>
              <LineContent width='140px' />
              <div className='graph-container'>
                <GraphBar />
                <SimpleCircle w={19} h={16} isCircular />
              </div>
            </div>
            <div className='block-container'>
              <LineContent width='145px' />
              <div className='graph-container'>
                <GraphBar />
                <SimpleCircle w={19} h={16} isCircular />
              </div>
            </div>
          </div>
        </CardContentCalifications>
      </SectionLayout>
      <SectionLayout>
        <CardHeader>
          <div>
            <SimpleCircle w={48} h={48} isCircular />
            <LineContent width='100px' />
          </div>
        </CardHeader>
        <CardContentReports>
          <div className='left last-section'>
            <div className='left-top'>
              <div className='pair'>
                <LineContent width='51px' height='23px' />
                <LineContent width='40px' height='16px' />
              </div>
              <div className='pair'>
                <LineContent width='51px' height='23px' />
                <LineContent width='40px' height='16px' />
              </div>
              <Separator h={70} />
              <div className='pair'>
                <LineContent width='51px' height='23px' />
                <LineContent width='70px' height='23px' />
              </div>
            </div>
            <LineContent width='250px' height='40px' />
          </div>
          {!isMobile && (
            <>
              <Separator />
              <div className='right'>
                <div className='right-top'>
                  <div className='ball-container'>
                    <SimpleCircle w={16} h={16} isCircular />
                    <SimpleCircle w={16} h={16} isCircular />
                    <SimpleCircle w={16} h={16} isCircular />
                    <SimpleCircle w={16} h={16} isCircular />
                    <SimpleCircle w={16} h={16} isCircular />
                  </div>
                  <GhaphImgContainer>
                    <img src={GhaphImg} alt='graph' width='100%' />
                  </GhaphImgContainer>
                </div>
                <div className='graph-label'>
                  <LineContent width='56px' height='16px' />
                  <LineContent width='56px' height='16px' />
                </div>
              </div>
            </>
          )}
        </CardContentReports>
      </SectionLayout>
    </>
  );
};

export default ReputationSkeleton;
